import xss from 'xss'
import anchorme from 'anchorme'
// eslint-disable-next-line import/no-extraneous-dependencies
import * as AES from 'aes-js'
import store from '@/vuex/store'
import configs from '@/config'

const _getBlockContent = (block, parser) => {
  if (!block || !block.content || !block.content.value) return null
  const blockFormatted = block.content.value.replace(/\n/g, '')
  const doc = parser.parseFromString(blockFormatted, 'text/html')
  const textContent = doc.body.textContent.trim()

  const defaultTitles = ['Click to add heading', 'Click to add content', 'Click to add subheading', 'Click to add caption']
  if (defaultTitles.includes(textContent)) return null
  return textContent
}

const getFirstCanvasBlockContent = (canvasBlocks) => {
  const blocks = Object.values(canvasBlocks)
  let content = null
  const parser = new DOMParser()
  for (let i = 0; i < blocks.length; i++) {
    content = _getBlockContent(blocks[i], parser)
    if (content) break
  }
  return content
}

export default {
  sanitize(text, isAllowedUnformattingTags, makeLinksClickable = true) {
    if (!text) return text

    const options = {
      whiteList: {
        i: [],
        u: [],
        b: [],
        em: [],
        br: [],
        ul: [],
        ol: [],
        li: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        sup: [],
        sub: [],
        strong: [],
        p: ['class'],
      },
    }

    if (isAllowedUnformattingTags) {
      options.whiteList = {
        ...options.whiteList,
        a: ['href', 'class', 'target'],
        source: ['src', 'type'],
        iframe: ['src', 'width', 'height', 'frameborder'],
        video: ['width', 'height', 'controls', 'autoplay'],
        audio: ['width', 'height', 'controls', 'autoplay'],
      }
    }

    const sanitizedText = xss(text, options)

    if (!store.state.presentation.showHyperLink || !isAllowedUnformattingTags) {
      return sanitizedText
    }
    if (makeLinksClickable) {
      return anchorme(sanitizedText, {
        attributes: [
          {
            name: 'target',
            value: 'blank',
          },
          {
            name: 'class',
            value: 'text-hyper-link',
          },
        ],
      })
    }
    return sanitizedText
  },

  formatNumber: (number) => {
    if (!number) return 0
    if (!store.state.presentation.language) return number

    return parseFloat(number).toLocaleString(store.state.presentation.language)
  },

  decryptText: (encryptedText) => {
    if (!encryptedText) {
      return encryptedText
    }
    const secretKeyHex = configs.cryptoEncryptionKey
    const secretKeyBytes = AES.utils.hex.toBytes(secretKeyHex)
    // Split the IV and the encrypted data
    const parts = encryptedText.split(':')
    const iv = AES.utils.hex.toBytes(parts[0])
    const encryptedBytes = AES.utils.hex.toBytes(parts[1])

    // Assuming AES-CBC mode, adjust if using a different mode
    // eslint-disable-next-line new-cap
    const aesCbc = new AES.ModeOfOperation.cbc(secretKeyBytes, iv)
    const decryptedBytes = aesCbc.decrypt(encryptedBytes)

    // Convert decrypted bytes back to text
    let decryptedText = AES.utils.utf8.fromBytes(decryptedBytes)

    // Assuming PKCS7 padding, remove padding
    const padding = decryptedText.charCodeAt(decryptedText.length - 1)
    decryptedText = decryptedText.slice(0, -padding)

    return decryptedText
  },

  countNumberOfWordsInString: (string) => {
    if (!string || !string.length) return 0
    const words = string.trim().split(/\s+/).filter((word) => word.length > 0)
    return words.length
  },

  getFirstCanvasBlockContent,
}
